import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

interface FormField {
  label: string;
  key: string;
  inputType: string;
  value?: any;
  options?: string[];
  required?: boolean;
}

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnChanges {
  @Input() formFields: FormField[] = [];
  form: FormGroup = this.fb.group({});

  constructor(private fb: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formFields'] && this.formFields) {
      this.buildForm();
    }
  }

  buildForm() {
    const group: any = {};
    this.formFields.forEach(field => {
      group[field.key] = [
        field.value || '',
        field.required ? Validators.required : []
      ];
    });
    this.form = this.fb.group(group);
  }

  onSubmit() {
    if (this.form.valid) {
      console.log('Dynamic Form Value:', this.form.value);
    }
  }
}
